module.exports = __webpack_public_path__ + "static/img/8-4.488dd2e6.jpg";